// @ts-nocheck
import axios from 'axios';
import { BASE_URL } from '../../../../queries/useDataEngine';

export const AttributeService = {
  getAttributeList: (params, loader = true) =>
    axios.get(`${BASE_URL}/custom-entity/attribute`, { params, loader }),

  getSingleAttributeDetails: (params) =>
    axios.get(`${BASE_URL}/custom-entity/attribute`, {
      params,
    }),

  createAttribute: (payload) =>
    axios.post(`${BASE_URL}/custom-entity/attribute`, payload),

  updateAttribute: (payload) =>
    axios.put(`${BASE_URL}/custom-entity/attribute`, payload),

  deleteAttribute: (params) =>
    axios.delete(`${BASE_URL}/custom-entity/attribute`, {
      params,
    }),

  uploadHtmlAttributeTemplate: (payload) =>
    axios.post(
      `${BASE_URL}/custom-entity/html-attribute/upload-template`,
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    ),

  getSystemGeneratedAttribute: (params, loader = true) =>
    axios.get(`${BASE_URL}/model-entity/system-generated-attributes`, {
      params,
      loader,
    }),

  downloadHtmlAttribute: (params, loader = false) =>
    axios
      .get(`${BASE_URL}/custom-entity/downloadAttribute`, {
        params,
        responseType: 'blob',
        loader,
      })
      .then((res) => ({
        data: {
          blob: res.data,
          headers: res.headers,
        },
      })),
};
